import './form-builder.config';
import controller from './form-builder.controller';
import template from './form-builder.html';

/**
 * @type {Router.Route}
 */
export const routeView = {
	template,
	controller,
	controllerAs:   '$ctrl',
	path:           '/form-builder/:formId?',
	title:          'menu.form-builder',
	reloadOnSearch: false,
};

/**
 * @type {Router.Route}
 */
export const routeNew = {
	template,
	controller,
	controllerAs:   '$ctrl',
	path:           '/form-builder/new/:classId',
	title:          'menu.form-builder',
	reloadOnSearch: false,
};
